import { render } from "./Job.vue?vue&type=template&id=3cd20e6b&ts=true"
import script from "./Job.vue?vue&type=script&lang=ts"
export * from "./Job.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__